'use client';
import { createContext, useContext, useEffect, useLayoutEffect, useState, ReactNode } from 'react';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export type TopBarTheme = 'light' | 'dark';

type NavThemeContextType = {
  topBarTheme: TopBarTheme;
  setTopBarTheme: (theme: TopBarTheme) => void;
};

const NavThemeContext = createContext<NavThemeContextType>({
  topBarTheme: 'dark',
  setTopBarTheme: () => {},
});

export const NavThemeProvider = ({
  children,
  defaultTheme = 'dark',
}: {
  children: ReactNode;
  defaultTheme?: TopBarTheme;
}) => {
  const [topBarTheme, setTopBarTheme] = useState<TopBarTheme>(defaultTheme);
  return (
    <NavThemeContext.Provider value={{ topBarTheme, setTopBarTheme }}>
      {children}
    </NavThemeContext.Provider>
  );
};

export const useNavTheme = () => useContext(NavThemeContext);

export const SetNavTheme = ({ theme }: { theme: TopBarTheme }) => {
  const { setTopBarTheme } = useNavTheme();
  useIsomorphicLayoutEffect(() => {
    setTopBarTheme(theme);
    return () => setTopBarTheme('dark');
  }, [theme]);
  return null;
};
